interface Props {
  disabled?: boolean;
  onClick(): void;
}

export function CameraFlipButton({ disabled, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Flip camera"
      style={{
        width: 'var(--tap)',
        height: 'var(--tap)',
        borderRadius: '50%',
        background: 'rgba(0,0,0,0.55)',
        color: 'var(--text)',
        border: '1px solid rgba(255,255,255,0.15)',
        fontSize: 20,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      ⇄
    </button>
  );
}
